import AlertIcons from 'components/AlertIcons';
import WeatherWidgetDetails from 'features/Weather/components/WeatherWidgetDetails/WeatherWidgetDetails';
import {
  getAlertDescription,
  getAlertSeverity,
} from 'features/Weather/features/WeatherAlerts/utils/alertData.utils';
import {
  getAlertSeverityColor,
  getAlertSeverityLabel,
} from 'features/Weather/features/WeatherAlerts/utils/alertSeverity.utils';
import { useId } from 'react';
import { joinClasses } from 'utils/componentStyles/style.utils';
import {
  severeWeatherAlertDetailGroups,
  severeWeatherAlertDetails,
} from '../../../../config/severeWeatherAlertDetails.config';
import {
  getSevereWeatherAlertAreaLabel,
  getSevereWeatherAlertHeadline,
} from '../../../../utils/severeWeatherAlerts.utils';
import SevereWeatherAlertDescription from '../../../SevereWeatherAlertDescription/SevereWeatherAlertDescription';

const SevereWeatherAlertDetails = ({ alert, area, className }) => {
  const headingId = useId();

  if (!alert || !area) return null;

  const headline = getSevereWeatherAlertHeadline(alert);
  const description = getAlertDescription(alert);
  const severity = getAlertSeverity(alert);
  const severityLabel = getAlertSeverityLabel(severity);

  return (
    <section
      aria-labelledby={headingId}
      className={joinClasses(
        'severe-weather-alert-details d-flex min-w-0 flex-column gap-2',
        className,
      )}
    >
      <header className="d-flex min-w-0 align-items-start gap-3">
        <div
          aria-hidden="true"
          className="d-flex flex-shrink-0 align-items-center justify-content-center rounded-2 p-2 text-white"
          style={{ backgroundColor: getAlertSeverityColor(severity) }}
        >
          <AlertIcons type={alert?.description ?? alert?.type} />
        </div>

        <div className="min-w-0 flex-grow-1">
          <div className="small text-uppercase text-secondary fw-semibold">
            {getSevereWeatherAlertAreaLabel(area)}
          </div>
          <h2 id={headingId} className="m-0 fs-6 fw-bold text-break">
            {headline}
          </h2>
          <div className="small text-secondary">{severityLabel} severity</div>
        </div>
      </header>

      <WeatherWidgetDetails
        selectedItem={alert}
        details={severeWeatherAlertDetails}
        layoutGroups={severeWeatherAlertDetailGroups}
        containerClassName="weather-map-detail-grid severe-weather-alert-detail-grid"
        iconSize={16}
        ariaLabel={`Details for ${headline}`}
      />

      <SevereWeatherAlertDescription description={description} />
    </section>
  );
};

export default SevereWeatherAlertDetails;
